const $collectionsSlider = $('[data-shop-collections-slider]');
const $productSlider = $('[data-shop-products-slider]');
const $blogSlider = $('[data-shop-blog-slider]');

document.addEventListener('DOMContentLoaded',() => {

  if ($collectionsSlider) {
    const options = {
      dots: true,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
          }
        }
      ]
    }
    $collectionsSlider.slick(options);
  }

  if ($productSlider) {
    const options = {
      dots: true,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
          }
        }
      ]
    }
    $productSlider.slick(options);
  }

  if ($blogSlider) {
    const options = {
      dots: true,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
          }
        }
      ]
    }
    $blogSlider.slick(options);
  }

});